<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>RCT1 Audit</v-toolbar-title>
                <v-spacer></v-spacer>

            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-btn color="accent" class="float-right" :loading="loader" @click="auditRCT1Records">Audit RCT1
                            Records</v-btn>
                    </v-col>

                    <v-col cols="12">
                        <v-data-table :items-per-page="pageItems" :headers="headers" :items="auditData" :search="search"
                            :mobile-breakpoint="zeroValue">

                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
export default {
    components: {
    },
    data: () => ({
        zeroValue: 0,
        totalDebt: 0,
        search: "",
        enableCreate: true,
        searchingProduct: false,
        accountDialog: false,
        accountItem: {},
        pageItems: 100,
        messageDialog: false,
        message: null,
        debtItem: {},
        accountId: null,
        dialog: false,
        customer: {},
        Balance: null,
        amount: null,
        accounts: [],
        auditData: [],
        loader: false,
        date: new Date().toISOString().substr(0, 10),
        dateReadonly: "",
        todayDate: new Date().toISOString().substr(0, 10),
        headers: [
            { text: "Customer Id", value: "CustomerId" },
            { text: "Customer Subscriber Id", value: "SubscriberId" },
            { text: "Audit Subscriber Id", value: "AuditSubscriberId" },
            { text: "Rct1 Id", value: "AuditId" },
        ],
        cashierHeaders: [
            { text: "Name", value: "ocrd.Name" },
            { text: "Action", value: "action" },
            { text: "Message", value: "message" },
        ],
        fields: {
            Name: "Name",
            Balance: "Balance",
        },
        debtors: [],
    }),
    computed: {
        role() {
            return localStorage.getItem("userRole");
        },
        userRole() {
            return localStorage.getItem("userRole");
        }
    },
    methods: {
        auditRCT1Records() {
            var subscriber_id = localStorage.getItem("subscriber_id");
            var url = `/audit-rct1-records/${subscriber_id}`;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("get", url)
                .then((res) => {
                    self.loader = false;
                    if (res.ResultCode == 1200) {
                        if (res.ResponseData != null) {
                            self.auditData = res.ResponseData;
                        }
                        self.$refs.snackbar.show("audit successful", "green");
                    } else {
                        self.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        updateDebtors() {
            var subscriber_id = localStorage.getItem("subscriber_id");
            var url = `/update-debtor-records/${subscriber_id}`;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("get", url)
                .then((res) => {
                    console.log(res, ' update res ');
                    self.loader = false;
                    if (res.ResultCode == 1200) {
                        self.$refs.snackbar.show("Update successful", "green");
                    } else {
                        self.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
    },
};
</script>